<template>
  <TextField
    :label="inputLabel"
    :place-holder="inputHint"
    :input="value"
    outlined dense
    :centered="false"
    :validatorTrigger="validatorTrigger"
    :inputName="inputName"
    :hideDetails="false"
    @setInput="
      (value) => {
        $emit('setInput', value);
      }
    "
    :validatorRule="getValidatorRule(inputName)"
  />
</template>

<script lang='ts'>
import { Component, Mixins } from 'vue-property-decorator';
import TextField from '@/components/Fields/TextField.vue';
import ProjectFieldsMixin from '@/components/Mixins/ProjectFieldsMixin.vue';

@Component({
  components: {
    TextField
  }
})
export default class ProjectTextField extends Mixins(ProjectFieldsMixin) {}
</script>

<style>
</style>
